import { inlineRule } from "@mdit/plugin-inline-rule";
import type { PluginSimple } from "markdown-it";

export const ins: PluginSimple = (md) => {
  inlineRule(md, {
    marker: "+",
    tag: "ins",
    token: "ins",
    nested: true,
    placement: "before-emphasis",
  });
};
